import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {

  isGoogleMapsLoaded = false;

  constructor() {
  }

  async loadGoogleMaps(apiKey: string) {
    if (!apiKey) {
      return;
    }
     {
      // If Google Maps is already loaded, immediately complete the observable.
      if (this.isGoogleMapsLoaded) {

        return;
      }

      // Define the global callback that the Google Maps script will call
      // @ts-ignore
      window['initAutocomplete'] = () => {
        this.isGoogleMapsLoaded = true;

      };
       // Create the script element to load the Google Maps API
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initAutocomplete`;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }
}
